export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';

export const ADD_SUCCESS_MESSAGE = 'ADD_SUCCESS_MESSAGE';

export const TOGGLE_DEVICE = 'TOGGLE_DEVICE';

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const TOGGLE_NOTIFICATIONS = 'TOGGLE_NOTIFICATIONS';

export const EXPAND_MENU = 'EXPAND_MENU';

export const SWITCH_EFFECT = 'SWITCH_EFFECT';

export const CLEAR_SITE_NOTIFICATIONS = 'CLEAR_SITE_NOTIFICATIONS';

export const QUEUE_SITE_UPDATE = 'QUEUE_SITE_UPDATE';

export const SOCKET_SITEUPDATENOTIFICATION = 'SOCKET_SITEUPDATENOTIFICATION';

export const SOCKET_SITETHEMEUPDATENOTIFICATION = 'SOCKET_SITETHEMEUPDATENOTIFICATION';

export const SOCKET_PLUGINUPDATENOTIFICATION = 'SOCKET_PLUGINUPDATENOTIFICATION';

export const SOCKET_BACKUPUPDATENOTIFICATION = 'SOCKET_BACKUPUPDATENOTIFICATION';
